module.exports = __webpack_public_path__ + "static/img-client-04-b0d3ca1907151f484d9d93ccaccb5d48.png";